<template>
  <div class="mydayPowerQuality">
    <div class="con">
      <div class="tree-left">
        <elUnitTree @checkFun="init" :dataList="virtualDeviceList"></elUnitTree>
      </div>
      <div class="right-table">
        <div class="search-input-btn" style="width:100%">
          <el-scrollbar style="height:100%;width: 100%;">
            <div class="my-search-i">
              <div class="input-small mr-20">
                <span>应用类型组：</span>
                <el-select
                  v-model="apptypeValue"
                  multiple
                  collapse-tags
                  placeholder="请选择"
                >
                  <el-option
                    label="全选"
                    value="全选"
                    @click.native="selectAll"
                  ></el-option>
                  <el-option
                    v-for="item in apptypeGroups"
                    :key="item.value"
                    :label="item.name"
                    :value="item.name"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="input-small ">
                <span>日期：</span>
                <el-date-picker
                  v-model="dayTimer"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </div>
              <el-button type="primary" plain @click="init" class="search-btn"
                >查询</el-button
              >
            </div>
          </el-scrollbar>
        </div>
        <div
          class="mychart"
          :style="{ width: '100%', height: `${chartHeights}px` }"
        >
          <div id="proportion" style="width:100%;height:100%"></div>
        </div>
        <div class="mytable" style="margin-top:10px">
          <el-table
            :data="dataList"
            :max-height="tabHeights"
            border
            style="width: 100%"
          >
            <template slot="empty">
              <span class="noData">
                <img src="@/assets/noData.png" alt="暂无数据" />
                <span class="text">暂无数据</span>
              </span>
            </template>
            <el-table-column label="序号" width="50" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="名称"
              width="180"
              align="center"
            >
            </el-table-column>
            <el-table-column
              v-for="(item, index) in columns"
              :key="index"
              :prop="item.name"
              :label="item.name"
              :align="item.al"
            >
            </el-table-column>
          </el-table>
        </div>
        <div class="el-loading-mask" v-show="loading">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import elUnitTree from "@/components/module/newTree/elUnitTree.vue";
import { getCountPower } from "../../api/abbNewApi";
let proportion;
export default {
  components: {
    elUnitTree,
  },
  props: [],
  data() {
    return {
      loading: false,
      chartHeights: Math.round(
        document.getElementById("app").clientHeight * 0.53
      ),
      tabHeights: Math.round(
        document.getElementById("app").clientHeight * 0.28
      ),
      vchartDate: [],
      nowVirtualDevice: undefined,
      nowApptypeGroups: [],
      dataObject: {},
      totalSize: 0,
      nowIndex: 0,
      options: {},
      from2name: {},
      apptypeValue: ["电流不平衡度"],
      dayTimer: new Date(),
      dataList: [],
      proportionData: {
        grid: {
          left: "3%",
          right: "3%",
          bottom: "8%",
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // Use axis to trigger tooltip
            type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
          },
        },
        toolbox: {
          show: true,
          showTitle: true, // 隐藏默认文字，否则两者位置会重叠
          right: "35",
          top: "20",
          feature: {
            magicType: {
              type: ["line", "bar", "stack", "tiled"],
              title: {
                line: "切换为折线图",
                bar: "切换为柱状图",
                stack: "切换为堆叠",
                tiled: "切换为平铺",
              },
            },
            saveAsImage: {
              show: true,
              title: "下载图片",
            },
            // dataView: { show: true, readOnly: true, lang: ['', '关闭'] },
          },
          tooltip: {
            // 和 option.tooltip 的配置项相同
            show: true,
            formatter: function(param) {
              return "<div>" + param.title + "</div>"; // 自定义的 DOM 结构
            },
            backgroundColor: "#fff",
            textStyle: {
              fontSize: 12,
            },
            extraCssText: "box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);", // 自定义的 CSS 样式
          },
        },

        legend: {
          data: [],
          type: "scroll",
          bottom: "0px",
          formatter: function(name) {
            return echarts.format.truncateText(
              name,
              100,
              "14px Microsoft Yahei",
              "…"
            );
          },
          tooltip: {
            show: true,
          },
          selected: {},
        },

        xAxis: {
          splitLine: {
            //网格线
            show: true,
          },
          type: "category",

          axisTick: {
            show: false,
          },
          axisLabel: {
            interval: 0,
            rotate: 0,
            inside: false,
          },
          axisLine: {
            show: false,
          },
          z: 99,
          data: [],
        },
        yAxis: {
          type: "value",
        },
        series: [],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      copynowVirtualDevice: [],
      mynum: 1,
    };
  },

  mounted() {
    //初始化图表
    this.init();
  },
  destroyed() {},
  computed: {
    getBackgroudImageStyle() {
      return this.$store.resourcesStore.getters.getBackgroudImageStyle;
    },
    getResourcesByName() {
      return this.$store.resourcesStore.getters.getResourcesByName;
    },
    nowSelectDate() {
      // this.dayTimer = (this.$store.cacheStore.getters.getNowSelectDate).getTime()
      return this.$store.cacheStore.getters.getNowSelectDate;
    },
    nowUnit() {
      return this.$store.unitStore.getters.getNowUnit;
    },
    virtualDeviceList() {
      var data = this.$store.deviceStore.getters.getReadDeviceTree;
      // console.log("树形结构",data);
      return isempty(data) ? [] : [deviceList(data)];
    },
    nowDateText() {
      return this.nowSelectDate.formatByDate("-");
    },
    variableTree() {
      if (this.nowVirtualDevice == undefined) {
        return [];
      }
      return this.$store.variableStore.getters.getVariableTree(
        this.nowVirtualDevice.no
      );
    },
    nowVariableNames() {
      //当前应该显示的变量fromname列表
      var ag = [];
      for (var i = 0, len = this.nowApptypeGroups.length; i < len; i++) {
        var item = this.nowApptypeGroups[i];
        if (item.id == -1 || item.id == -2) {
          ag = ag.concat(
            item.next.map((ni) => {
              return ni.id;
            })
          );
        } else {
          ag.push(item.id);
        }
      }
      var v1 = this.variableTree.filter((item) => {
        return ag.includes(item.no);
      });
      if (isempty(v1)) {
        return [];
      }
      var v2 = [];
      v1.forEach((item) => {
        item.next.forEach((i) => {
          v2.push(i.fromName); //fromName
        });
      });
      return v2;
    },
    apptypeGroups() {
      // console.log("下拉框",this.$store.variableStore.state.powerApptypeGroup);
      return this.$store.variableStore.state.powerApptypeGroup;
    },
    nowShowDataList() {
      //当前应该显示的数据列表
      var list = [];
      //只取出要显示的变量的数据
      for (var i = 0, len = this.nowVariableNames.length; i < len; i++) {
        var item = this.dataObject[this.nowVariableNames[i]];
        if (!isempty(item)) {
          if (parseFloat(item) !== NaN) {
            if (isnull(parseFloat(item))) {
              item = undefined;
            }
          }
          list.push(item);
        }
      }
      return list;
    },
    columns() {
      //列表的项，每个整点值
      var list = [];
      // list.push({
      // 	name: "名称"
      // })
      for (var i = 0; i < 24; i++) {
        list.push({
          al: "center",
          key: i + "时",
          name: (i < 10 ? "0" : "") + i + ":00",
        });
      }
      return list;
    },
    nowPage() {
      //按照页码来返回当前应该显示的列表
      var list = [];
      var baseList = this.nowShowDataList.filter((item, index) => {
        return (
          index >= this.nowIndex * this.pageLen &&
          index < (this.nowIndex + 1) * this.pageLen
        );
      });
      //排练数据，名称在第一个，后面按顺序显示数据
      for (var i = 0, len = baseList.length; i < len; i++) {
        var item = baseList[i][0];
        if (!isempty(item)) {
          var vlist = [];
          var name = this.from2name[item.variablename]
            ? this.from2name[item.variablename]
            : item.variablename;
          vlist.push(name.subByFirstChar("."));
          //取整点值
          for (var i2 = 0, len2 = item.data.length; i2 * 12 < len2; i2++) {
            var item2 = item.data[i2 * 12];
            if (isNaN(parseFloat(item2)) || isnull(parseFloat(item2))) {
              item2 = undefined;
            }
            vlist.push(item2);
          }
          list.push(vlist);
        }
      }
      return list;
    },
    allVariableName() {
      //所有的通讯变量名称
      var list = [];
      for (var i = 0, len = this.variableTree.length; i < len; i++) {
        var next = this.variableTree[i].next;
        for (var i2 = 0, len2 = next.length; i2 < len2; i2++) {
          var item = next[i2];
          this.from2name[item.fromName] = item.name;
          list.push(item.fromName); //fromName
        }
      }
      return list;
    },
    pageLen() {
      return this.nowVariableNames.length < 6
        ? 6
        : this.nowVariableNames.length;
    },
  },
  watch: {
    nowDevice(nv, ov) {
      this.dataObject = {};
    },
    nowShowDataList(nv, ov) {
      //获取到新的数据了，重新渲染
      this.nowIndex = 0;
    },
    allVariableName(nv, ov) {
      this.search();
    },
    nowSelectDate(nv, ov) {
      this.search();
    },
    copynowVirtualDevice(val) {
      this.mynum += 1;
      if (this.mynum == 2) {
        this.nowVirtualDevice = val;
      }
    },
  },
  methods: {
    checkFun(val) {
      this.copynowVirtualDevice = val;
    },
    selectDate(date) {
      this.$store.cacheStore.commit("setNowSelectDate", date);
      this.$refs.datePicker.hide();
    },
    //新下拉框
    selectAll() {
      //全选 先判断是否有选中的，有选中就清空
      if (this.apptypeValue.length == 1) {
        this.nowApptypeGroup = this.apptypeGroups;
        let idList = [];
        let valueList = [];
        this.apptypeGroups.forEach((item) => {
          idList.push(item.id);
          valueList.push(item.name);
        });
        this.$store.cacheStore.commit("setNowSelectAppTypeGroupIds", idList);
        this.apptypeValue = valueList;
      } else {
        this.nowApptypeGroup = [];
        this.$store.cacheStore.commit("setNowSelectAppTypeGroupIds", []);
        this.apptypeValue = [];
      }
    },
    getSearch() {
      this.nowVirtualDevice = this.copynowVirtualDevice;
      this.search();
    },

    search() {
      if (isempty(this.virtualDeviceList)) {
        return;
      }
      if (this.nowVirtualDevice == undefined) {
        this.$dialogMethod.showMessage("请先选中设备！");
        return;
      }
      // if (isempty(this.allVariableName)) {
      // 	return
      // }
      var deviceArr = this.nowVirtualDevice.filter(
        (item) => item.type == "virtualDevice"
      );
      var deviceStr = "";
      deviceArr.forEach((item) => {
        deviceStr += "," + item.no;
      });
      var str = "";
      this.apptypeValue.forEach((item) => {
        str += "," + item;
      });
      // console.log("字符串",str.slice(1));
      var d = {
        dateType: "day",
        deviceNo: deviceStr.slice(1),
        electricPower: str.slice(1),
        time: this.dayTimer.getTime(),
      };

      return;
    },
    exportExcel() {},
    init() {
      this.dataList = [];
      this.apptypeValue.map((v) => {
        this.dataList.push({ name: v });
      });

      this.proportionData.xAxis.data = [];
      var a = [];
      var aa = [];
      for (let i = 0; i < 24; i++) {
        var e = (i < 10 ? "0" : "") + i + ":00";
        this.proportionData.xAxis.data.push(e);
        var d = Math.round(Math.random() * 10 + 20);
        a.push(d);
        this.dataList.map((v) => {
          v[e] = d;
        });
        // this.dataList[0][e] = d;
      }
      this.dataList.map((v) => {
        aa.push({
          name: v,
          data: a,
          type: "line",
          smooth: true,
          stack: "total",
          emphasis: {
            focus: "series",
          },
        });
      });
      this.proportionData.series = aa;
      proportion = echarts.init(document.getElementById("proportion"));
      proportion.setOption(this.proportionData, true);
    },

    reloadChart(lists) {
      var legendData = [];
      var seriesData = [];
      var index = 0;
      for (let k in lists) {
        for (let v in lists[k]) {
          legendData.push({
            name: k + " " + this.convertName(v),
            icon: "roundRect",
          });

          this.dataList.push({
            name: k + " " + this.convertName(v),
          });
          seriesData.push({
            name: k + " " + this.convertName(v),
            data: [],
            type: "line",
            stack: "total",
            emphasis: {
              focus: "series",
            },
          });

          for (let t in lists[k][v]) {
            seriesData[index].data.push(lists[k][v][t]);
            this.dataList[index][t] = lists[k][v][t];
          }
          index += 1;
        }
      }
      this.proportionData.series = seriesData;
      this.proportionData.legend.data = legendData;
      console.log("this.proportionData", this.proportionData);
      proportion.setOption(this.proportionData, true);
    },
    convertName(name) {
      if (name == "voltageUnbalance") {
        return "电流不平衡";
      } else if (name == "currentUnbalance") {
        return "电压不平衡";
      } else if (name == "frequencyDeviation") {
        return "频率偏差";
      } else if (nam == "voltageDistortionRate") {
        return "电压谐波畸变率";
      } else if (nam == "oddHarmonicInclusionRate") {
        return "奇数谐波含有率";
      } else if (nam == "evenHarmonicInclusionRate") {
        return "偶数谐波含有率";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.mydayPowerQuality {
  padding-top: 0 !important;

  .con {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;

    .search-input-btn {
      margin-bottom: 0px;
    }

    .tree-left {
      width: 3rem;
      height: 90vh;
      padding: 12px;
      box-sizing: border-box;
      background-color: #fff;
      border-right: 8px solid #f7f7f7;

      .btns {
        display: flex;
        // justify-content: space-evenly;
        margin-bottom: 8px;

        button {
          margin-right: 12px;
        }

        .el-button--mini {
          padding: 7px 10px !important;
        }

        .el-button + .el-button {
          margin-left: 0px;
        }
      }

      .search {
        display: flex;
        justify-content: center;
        margin-bottom: 12px;
      }
    }

    .right-table {
      width: calc(100% - 3.08rem);
      height: 100%;
      padding: 2px 20px 20px 20px;
      box-sizing: border-box;
      background-color: #fff;
      position: relative;
    }
  }
}
</style>
